// extracted by mini-css-extract-plugin
export default {"fileBox":"FileDisplayBlock_fileBox__wgmKV","elementHeading":"FileDisplayBlock_elementHeading__lug0e","icon":"FileDisplayBlock_icon__Woqdh"};